import { FEATURE_FLAGS } from '@modules/feature-flags/constants';
import { FeatureFlags } from '@modules/feature-flags/types';

export const fetchFeatureFlags = async (): Promise<FeatureFlags[]> => {
  // TODO: REMOVE FEATURE FLAG LOGIC. Replace below line with an endpoint call to get feature flags
  return await new Promise((resolve) => {
    resolve(FEATURE_FLAGS);
  });
};
